import { UPDATE_REQUESTS } from "Redux/Actions/requestsActions";

const INITIAL_STATE = {
  alumniRequests: [],
  recruiterRequests: [],
  etapesData: [],
  groupsData: [],
};

const requestsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_REQUESTS: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default requestsReducer;
